import CookiesController from '@/controllers/cookies_controller'

export default class extends CookiesController {
  static targets = [
    'attachinary',
    'url',
    'caption',
    'captionTools',
    'enableButton',
    'disableButton',
    'disableCaption',
    'errorMessage',
  ]

  attachinaryTargetConnected(input) {
    // These events are triggered by jQuery, so we need to attach jQuery event listeners
    $(input)
      .on('attachinary:fileadded', this.#enableOrDisableButton.bind(this))
      .on(
        'attachinary:fileadded',
        this.#clickGenerateSuggestionButton.bind(this),
      )
      .on('attachinary:fileremoved', this.#enableOrDisableButton.bind(this))
  }

  connect() {
    this.#enableOrDisableButton()
  }

  urlTargetConnected(input) {
    input.addEventListener('input', this.#enableOrDisableButton.bind(this))
    input.addEventListener(
      'focusout',
      this.#clickGenerateSuggestionButton.bind(this),
    )
  }

  disableButtonTargetConnected(button) {
    button.addEventListener('click', this.#disableSuggestions.bind(this))
  }

  enableButtonTargetConnected(button) {
    button.addEventListener('click', this.#generateCaption.bind(this))
  }

  #disableSuggestions() {
    this.setCookie('cesp_disable_auto_image_descriptions', 1, 365)
    this.disableCaptionTarget.classList.add('hidden')
    this.enableButtonTarget.classList.remove('hidden')
    this.errorMessageTarget.classList.add('hidden')
  }

  #enableSuggestions(event) {
    this.deleteCookie('cesp_disable_auto_image_descriptions')
    this.enableButtonTarget.classList.add('hidden')
    this.disableCaptionTarget.classList.remove('hidden')
  }

  #clickGenerateSuggestionButton() {
    if (!this.cookiePresent('cesp_disable_auto_image_descriptions')) {
      this.enableButtonTarget.click()
    }
    this.captionToolsTarget.classList.remove('hidden')
  }

  #enableOrDisableButton() {
    this.enableButtonTarget.disabled =
      this.captionTarget.disabled || // Currently generating caption
      !(this.attachinaryTarget.disabled || this.urlTargets[0]?.value)
  }

  #generateCaption(event) {
    this.#enableSuggestions()

    this.captionTarget.disabled = true
    event.target.disabled = true

    const loadingIcon = document.createElement('div')
    loadingIcon.classList.add('loading-caption')
    loadingIcon.innerHTML =
      '<i class="far fa-sparkles"></i>&nbsp&nbsp<i class="fas fa-sync fa-spin fa-fw"></i>'
    this.captionTarget.insertAdjacentElement('afterend', loadingIcon)

    const oldCaption = this.captionTarget.value
    this.captionTarget.value = ' ' // Don't show placeholder

    const hiddenField = this.element.querySelector(
        `input[type=hidden][name='${this.attachinaryTarget.name}']`,
      ),
      params = hiddenField.value
        ? JSON.parse(hiddenField.value)[0]
        : { path: this.urlTarget.value }

    const csrfToken = document.querySelector("[name='csrf-token']").content
    fetch('/api/v1/admin/ai/image', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(params),
    }).then(async (response) => {
      loadingIcon.remove()

      let text
      if (response.ok && (text = await response.text())) {
        this.captionTarget.value = text
        this.errorMessageTarget.classList.add('hidden')
        event.target.disabled = false
      } else {
        // Empty response means there was an error
        this.captionTarget.value = oldCaption
        this.errorMessageTarget.classList.remove('hidden')
      }

      this.captionTarget.disabled = false
    })
  }
}
